export default __webpack_public_path__ + "static/media/bus-sideview.a9e76b31.svg";